import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { DragSliderContainer } from '../koko-framework/ui/draggable'
import { v, au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
import { PigPenController } from '../controller/PigPenController'
import { Input } from '../koko-framework/ui/input'
import { GameTimeController } from '../controller/GameTimeController'
import { PIGPEN } from '../model/GameModel'
import gameState from '../model/GameModel'
import { LINE_HEIGHT } from '../model/PigPenModel'
import * as PIXI from 'pixi.js'
import { SimpleCustomKeyboard } from '../koko-framework/ui/SimpleCustomKeyboard'
import { keyboardSetup } from '../model/CustomKeyboard'
import { setupClicker } from '../controller/ButtonController'

export class PigPenView extends koko.view {
    controller = null;
    timeController = null;
    answerInput = null;
    slider = null;
    canSubmitAnswer = false;
    popOpen = false;
    keyboardOpen = false;
    hintAllowed = false;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            {name:'gameContainer', type:'container'},

            { type: 'sprite', parent: 'gameContainer', id: 'BG_pattern', name: 'bg', x: -280, y: 0, width: 1326, height: 1355},

            { type: 'sprite', parent: 'gameContainer', id: 'pigpen_title', name: 'title', x: vp.centerX, y: 286, width: 120, height: 62, anchorX: 0.5, anchorY: 0},

            { type: 'bmptext', parent: 'gameContainer', text: 'Use the pig pen to decipher the\nfollowing encrypted message.', font: 'typrighter_small', size: 30, tint: 0, name: 'instructions', align:'center', x: vp.centerX, y: 358},

            { type: 'sprite', parent: 'gameContainer', id: 'question_carrier', name: 'message_carrier', x: 120, y: 423, width: 525, height: 204},
            { type: 'container', parent: 'gameContainer', name: 'questionContainer', x: vp.centerX, y: 443},

            { type: 'shape', parent: 'gameContainer', name: 'closeKeyboardOutside', x: 0, y: 920, width: 765, height: 600, fill: 0, alpha: 0},

            { type: 'bmptext', parent: 'gameContainer', text: 'Insert answer:', font: 'typrighter_small', size: 30, tint: 0, name: 'decodedTitle', align:'center', x: vp.centerX, y: 946},
            { type: 'bmptext', parent: 'gameContainer', text: 'ANSWER', font: 'Bebas_small', size: 36, tint: 0, name: 'answerText', x: vp.centerX, y: 985},

            { type: 'sprite', parent: 'gameContainer', id: 'cipher_entryField', name: 'entryField', x: 152, y: 1026, width: 460, height: 6},

            { name: 'pippetsContainer', parent: 'gameContainer', type: 'container', x: vp.centerX, y: 902 },
            { name: 'pigPensContainer', parent: 'gameContainer', type: 'container', x: 0, y: 690 },

            { type: 'sprite', parent: 'gameContainer', id: 'arrow_left_on', name: 'arrow_left_btn', x: 256, y: 912, width: 74, height: 42, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', parent: 'gameContainer', id: 'arrow_right_on', name: 'arrow_right_btn', x: 508, y: 912, width: 74, height: 42, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', parent: 'gameContainer', id: 'hint_btn_disabled', name: 'hint_btn', x: vp.centerX, y: 650, width: 162, height: 55, anchorX: 0.5, anchorY: 0.5},

            // { type: 'sprite', parent: 'gameContainer', id: 'checkAnswerOff_btn', name: 'checkAnswer_btn', x: 165, y: 1060, width: 434, height: 105},
            { type: 'sprite', parent: 'gameContainer', id: 'checkAnswerOff_btn', name: 'checkAnswer_btn', x: 165, y: 1060, width: 434, height: 105},
        ], this.container);

        this.controller = new PigPenController();
        this.controller.showPhrase(this.children.questionContainer);

        let maxPhraseHeight = 4 * LINE_HEIGHT;
        if (this.children.questionContainer.height < maxPhraseHeight) {
            let topSpace = (maxPhraseHeight - this.children.questionContainer.height) / 2;
            this.children.questionContainer.y = 440 + topSpace;
        }

        this.children.answerText.anchor.x = 0.5;

        this.children.instructions.anchor.x = 0.5;
        this.children.decodedTitle.anchor.x = 0.5;

        this.populatePigPenSelector();

        this.resize();

        if (this.answerInput == null) {
            this.answerInput = new Input(this.children.answerText, 400, 70, -200, -30);
	    	this.answerInput.setColors(0, 0);
		    this.answerInput.setDesktopClasses('answerInput', 'idle', 'active');
		    this.answerInput.setDisplayLength(23, "...");
            /* this.answerInput.validation(function(){
                var uname = this.val; // _t.removeKeywords(this.val);
                // _t.children.dataField_error.visible = uname.length < 2 || uname.length > 30;
            }); */
            this.answerInput.mobileEditCallback = () => {au.play('button', 1, false); this.openKeyboard()};
            this.answerInput.desktopEditCallback = () => {au.play('button', 1, false); this.closeKeyboard()};
            this.answerInput.desktopEnterPressedCallback = () => {au.play('button', 1, false); this.submitAnswer()};
            if (koko.client.isTouch === true) {
                this.answerInput.desktopEditCallback = this.answerInput.mobileEditCallback;
            }
        }
        this.answerInput.resize();

        this.canSubmitAnswer = false;

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.closeKeyboardOutside.interactive = true;
        this.children.closeKeyboardOutside.on(event, () => {if (this.keyboardOpen) {au.play('button', 1, false);} this.closeKeyboard()});
        */
        setupClicker(this.children.closeKeyboardOutside, () => {if (this.keyboardOpen) {au.play('button', 1, false);} this.closeKeyboard()});

        this.hintAllowed = false;
        /*
        this.children.hint_btn.interactive = false;
        this.children.hint_btn.on(event, () => {if (!this.popOpen) {au.play('button', 1, false);} this.showHint()});
        */
        setupClicker(this.children.hint_btn, () => {if (!this.popOpen) {au.play('button', 1, false);} this.showHint()});
        this.children.hint_btn.interactive = false;
    }

    resize () {
        // console.log('resize called');
        // v.get('ingamehud').resize();
        if (this.answerInput) {
            this.answerInput.resize();
        }

        // console.log(app.viewPort, 225 * 3 + 190);

        if (app.viewPort.width + app.viewPort.x * 2 < 225 * 3 + 190) {
            if (this.slider) {
                this.slider.enable();
            }
            this.children.pippetsContainer.visible = true;
            this.children.arrow_left_btn.visible = true;
            this.children.arrow_right_btn.visible = true;
        } else {
            this.children.pigPensContainer.x = -1.5 * 225;
            if (this.slider) {
                this.slider.disable();
            }
            this.children.pippetsContainer.visible = false;
            this.children.arrow_left_btn.visible = false;
            this.children.arrow_right_btn.visible = false;
        }
    }

    transitionIn (){
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35});
        
        v.get('ingamehud').transitionIn(this);

        this.timeController = new GameTimeController();
        this.timeController.init(PIGPEN.time);

        this.startGame();

        this.answerInput.enable();
        this.enableSlider();
        this.resize();

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.checkAnswer_btn.interactive = true;
        this.children.checkAnswer_btn.on(event, this.submitAnswer);

        this.children.arrow_left_btn.on(event, this.prevPage);
        this.children.arrow_left_btn.interactive = true;
        this.children.arrow_right_btn.on(event, this.nextPage);
        this.children.arrow_right_btn.interactive = true;
        */
        setupClicker(this.children.checkAnswer_btn, this.submitAnswer);
        setupClicker(this.children.arrow_left_btn, this.prevPage);
        setupClicker(this.children.arrow_right_btn, this.nextPage);

        this.keyboardOpen = false;
        this.popOpen = false;

        this.showTutorial();
    }

    transitionOut (){
        this.closeKeyboard();
        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
        v.get('ingamehud').transitionOut();
        this.stopGame();

        if (this.answerInput) {
            this.answerInput.disable();
            this.answerInput.remove();
            this.answerInput = null;
        }
        this.popOpen = false;
    }

    transitionOutDone = () => {
        // gsap.killAll();
        this.clearSlider();
        this.controller.destroyPhraseView();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    startGame () {
        this.enable();
   
        app.removeUpdateListener('ingame');

        /*
        game = new GameController();
        */
        // game.init();
           
        
		app.addUpdateListener('ingame', function(delta){ 
            this.update(delta);
        }.bind(this));
        

        app.addResizeListener('ingame', function(){
            this.resize();
        }.bind(this));
    }

    stopGame (){ 
        app.removeUpdateListener('ingame');
        while (app.updateListeners['ingame']) {
            app.removeUpdateListener('ingame');
        }

        app.removeResizeListener('ingame');
        while (app.resizeListeners['ingame']) {
            app.removeResizeListener('ingame');
        }
    }

    update($delta) {
        if (!this.popOpen) {
            this.timeController.update($delta);

            if (this.answerInput.val.length > 0) {
                this.children.checkAnswer_btn.texture = PIXI.Texture.from('checkAnswer_btn.png');
                this.canSubmitAnswer = true;
            } else {
                this.children.checkAnswer_btn.texture = PIXI.Texture.from('checkAnswerOff_btn.png');
                this.canSubmitAnswer = false;
            }

            if (!this.hintAllowed && this.timeController.rank < 3) {
                this.hintAllowed = true;
                this.children.hint_btn.interactive = true;
                this.children.hint_btn.texture = PIXI.Texture.from('hint_btn_active.png');
            }
        } else {
            this.timeController.pauseUpdate($delta);
            this.canSubmitAnswer = false;
        }
    }

    pippetSpacing = 25;

    populatePigPenSelector() {
        let view = this;
        let page = 0;
        let container = view.children.pigPensContainer;
        let vp = app.viewPort;
        this.playersListSprites = [];
        while (page < 4) {
            let px = vp.centerX + page * 225;
            let pigPenSprite = PIXI.Sprite.from('pigpen_' + (page + 1) + '.png');
            pigPenSprite.anchor.x = 0.5;
            pigPenSprite.anchor.y = 0;
            pigPenSprite.scale.x = 0.5;
            pigPenSprite.scale.y = 0.5;
            pigPenSprite.x = px;
            pigPenSprite.y = 0;
            container.addChild(pigPenSprite);
            page++;
        }
        // add pippets
        container = view.children.pippetsContainer;
        this.createPippets(container, page);

        return page;
    }

    createPippets(container, pages) {
        var pippetX = -((pages - 1) * this.pippetSpacing)/2;
        for (var i = 0; i < pages; i++) {
            var newPippet = null;
            if (i === 0) {
                newPippet = PIXI.Sprite.from('carousel_active.png');
            } else {
                newPippet = PIXI.Sprite.from('carousel_inactive.png');
            }
            newPippet.anchor.x = 0.5;
            newPippet.anchor.y = 0;
            newPippet.scale.x = 0.5;
            newPippet.scale.y = 0.5;
            newPippet.x = pippetX;
            container.addChild(newPippet);
            pippetX += this.pippetSpacing;
        }
    }

    updatePippets() {
        let page = Math.abs(Math.floor((this.children.pigPensContainer.x + 113) / 225));
        // console.log(page);
        for (var i = 0; i < 4; i++) {
            var pippet = this.children.pippetsContainer.getChildAt(i);
            if (i === page) {
                pippet.texture = PIXI.Texture.from('carousel_active.png');
            } else {
                pippet.texture = PIXI.Texture.from('carousel_inactive.png');
            }
        }

        if (this.children.pigPensContainer.x >= 0) {
            this.children.arrow_left_btn.texture = PIXI.Texture.from('arrow_left_off.png');
        } else {
            this.children.arrow_left_btn.texture = PIXI.Texture.from('arrow_left_on.png');
        }
        if (this.children.pigPensContainer.x <= -675) {
            this.children.arrow_right_btn.texture = PIXI.Texture.from('arrow_right_off.png');
        } else {
            this.children.arrow_right_btn.texture = PIXI.Texture.from('arrow_right_on.png');
        }
    }

    nextPage = () => {
        if (!this.popOpen && this.children.pippetsContainer.visible && this.children.pigPensContainer.x > -675) {
            let page = Math.abs(Math.floor((this.children.pigPensContainer.x + 113) / 225));
            page++;
            this.gotoPage(page);
        }
    }

    prevPage = () => {
        if (!this.popOpen && this.children.pippetsContainer.visible && this.children.pigPensContainer.x < 0) {
            let page = Math.abs(Math.floor((this.children.pigPensContainer.x + 113) / 225));
            page--;
            this.gotoPage(page);
        }
    }

    gotoPage(page) {
        if (page > 3) {
            page = 3;
        }
        if (page < 0) {
            page = 0;
        }
        // console.log('goto slide!', page);
        this.slider.snapDistance = 225;
        this.slider.gotoSlide(page, 0.1);
        this.slider.snapDistance = 0;
        au.play('shiftArrow', 1, false);
    }

    enableSlider() {
        if (this.slider == null) {
            var sliderHitArea = new PIXI.Graphics();
            sliderHitArea.beginFill(0,0);
            sliderHitArea.drawRect(0,0,765 * 2, 190);
            sliderHitArea.endFill();
            sliderHitArea.interactive = true;
            this.children.pigPensContainer.addChildAt(sliderHitArea, 0);

            this.slider = new DragSliderContainer(this.children.pigPensContainer, 'x', 0, 225, 3, {complete:(drag) => {
                this.updatePippets();
            },
            update:(drag) => {
                this.updatePippets();
            }}, false, 'x');
            this.slider.animTime = 0.22;
            this.slider.snapDistance = 0;
            this.elements = [this.slider];
        }
        // this.slider.gotoSlide(0);
        // console.log(this.slider);
        this.slider.enable();
        this.updatePippets(this.slider.index);
    }

    clearSlider() {
        if (this.slider) {
            this.slider.disable();
            while (this.children && this.children.pippetsContainer.children.length > 0) {
                let c = this.children.pippetsContainer.children[0];
                this.children.pippetsContainer.removeChild(c);
                c.destroy();
            }
            while (this.children && this.children.pigPensContainer.children.length > 0) {
                let c = this.children.pigPensContainer.children[0];
                this.children.pigPensContainer.removeChild(c);
                c.destroy();
            }
        }
        this.slider = null;
    }

    submitAnswer = (e) => {
        if (this.keyboardOpen) {
            this.closeKeyboard();
        }
        if (this.canSubmitAnswer && !this.popOpen) {
            if (this.controller.checkAnswer(this.answerInput.val)) {
                au.play('correct', 1, false);
                this.stopGame();
                gameState.setGameScore(this.timeController.rank);
                // this.transitionOut();
                this.popOpen = true;
                v.get('gameover').transitionIn(this);
            } else {
                au.play('wrong', 1, false);
                this.popOpen = true;
                this.slider.disable();
                this.answerInput.disable();
                v.get('ingamehud').enabled = false;
                v.get('wronganswer').transitionIn(this);
            }
        }
    }

    popClosed = () => {
        if (this.popOpen) {
            this.popOpen = false;
            // this.clicksAllowed = true;
            this.answerInput.enable();
            v.get('ingamehud').enabled = true;
            if (this.children.pippetsContainer.visible) {
                this.slider.enable();
            }
        }
    }

    showQuitPop = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            this.answerInput.disable();
            this.closeKeyboard();
            v.get('ingamehud').enabled = false;
            v.get('quitpopup').transitionIn(this);
        }
    }

    showHint = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            this.answerInput.disable();
            v.get('ingamehud').enabled = false;
            v.get('pphint').transitionIn(this);
        }
    }

    showTutorial = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            this.answerInput.disable();
            v.get('ingamehud').enabled = false;
            v.get('pptutorial').transitionIn(this);
        }
    }

    openKeyboard = () => {
        if (!this.keyboardOpen && !this.popOpen) {
            let vp = app.viewPort;
            this.customKeyboard = new SimpleCustomKeyboard(keyboardSetup);
            this.keyboardView = this.customKeyboard.createKeyboard(vp.centerX, 1044, this.container, this.handleCustomKeyboardClick, 0);
            this.keyboardView.alpha = 0;
            this.keyboardOpen = true;
            gsap.to(this.keyboardView, {alpha:1, duration: 0.35});

            let currentVal = this.answerInput.val;
            this.children.answerText.text = currentVal + '|';
        } else
        if (this.keyboardOpen && !this.popOpen) {
            this.closeKeyboard();
        }
    }

    closeKeyboard = () => {
        if (this.keyboardOpen) {
            this.keyboardOpen = false;
            gsap.to(this.keyboardView, {alpha:0, duration: 0.35, onComplete: this.customKeyboard.removeKeyboard});
    
            let currentVal = this.answerInput.val;
            if (currentVal !== '') {
                this.children.answerText.text = currentVal;
            } else {
                this.children.answerText.text = 'ANSWER';
            }
        }
    }

    handleCustomKeyboardClick = (kId, e) => {
        if (this.keyboardOpen && !this.popOpen) {
            // console.log('custom keyboard: ', kId, e);
            if (kId.toUpperCase() === 'CLOSE') {
                this.closeKeyboard();
            } else {
                let currentVal = this.answerInput.val;
                if (kId.toUpperCase() === 'SPC' || kId.toUpperCase() === 'SPACE') {
                    currentVal += ' ';
                } else
                if (kId.toUpperCase() === 'DEL') {
                    if (currentVal.length > 0) {
                        currentVal = currentVal.substr(0, currentVal.length - 1);
                    }
                } else {
                    currentVal += kId;
                }
                this.answerInput.val = currentVal;
                this.children.answerText.text = currentVal + '|';
            }
        }
    }
}